import POST_COMPONENT_TYPE from '../postComponentType';
import FattyLiverHero from '../../../assets/images/fatty-liver-hero-section.png';
import { IconType } from '../../../components/BannerWithList';

const fattyLiverData = {
  key: 'fatty-liver',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.fatty-liver.name',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: FattyLiverHero,
      text: 'learnMoreContent.fatty-liver.banner.text',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.fatty-liver.importance.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.fatty-liver.importance.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.importance.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.importance.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.importance.listItem4',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.fatty-liver.overweight.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.fatty-liver.overweight.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.overweight.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.overweight.listItem3',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.fatty-liver.measured.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title: 'learnMoreContent.fatty-liver.measured.listGroup1.title',
          items: [
            {
              text: 'learnMoreContent.fatty-liver.measured.listGroup1.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.measured.listGroup1.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.measured.listGroup1.listItem3',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.fatty-liver.improvement.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          title: 'learnMoreContent.fatty-liver.improvement.listGroup1.title',
          items: [
            {
              text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem2',
              type: 'text',
              subItems: [
                {
                  text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem2.subItem1',
                  type: 'text',
                },
                {
                  text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem2.subItem2',
                  type: 'text',
                },
              ],
            },
            {
              text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem4',
              type: 'text',
            },
            {
              text: 'learnMoreContent.fatty-liver.improvement.listGroup1.listItem5',
              type: 'text',
            },
          ],
        },
      ],
    },
  ],
};

export default fattyLiverData;
